import { FC } from "react";

import { Box } from "@mui/material";

import { useIsDesktop } from "@hooks/layout";

import { TQuickFiltersCategory } from "@store/actions/quickFilters";

import { useWindowSize } from "usehooks-ts";

import { QuickFilter } from "../QuickFilter";

export const QuickFilterCategory: FC<TQuickFiltersCategory> = ({ _id, quickFilters, title, type, color }) => {
  const { width } = useWindowSize();
  const isDesktop = useIsDesktop();

  const getColumns = () => {
    let columns = "";
    if (width > 1250) {
      columns = "repeat(5, 1fr)";
    }
    if (width < 1250) {
      columns = "repeat(3, 1fr)";
    }
    if (width < 700) {
      columns = "repeat(2, 1fr)";
    }
    return columns;
  };

  return (
    <Box
      gridColumn="span 12"
      padding={isDesktop ? "46px 32px 32px" : "40px 24px 24px"}
      sx={{
        background: "#D7BFA4",
        borderRadius: "8px",
      }}
    >
      <Box
        display="grid"
        justifyContent="center"
        alignItems="center"
        width="100%"
        gap={isDesktop ? "24px" : "16px"}
        gridTemplateColumns={getColumns()}
        sx={{ position: "relative" }}
      >
        <Box
          position="absolute"
          sx={{
            top: 0,
            transform: `translateY(calc(${isDesktop ? "-46px" : "-40px"} - 50%))`,
            background:
              "linear-gradient(92.95deg, #BA905C 0.82%, #FFD29B 33.73%, #FFE0B1 47.65%, #FFD29B 61.53%, #BA905C 99.48%)",

            paddingTop: "1px",
            borderRadius: "4px",
          }}
        >
          <Box
            sx={{
              background: color,
              padding: "8px 16px",
              borderRadius: "4px",
              textTransform: "uppercase",
              minWidth: "max-content",
              fontWeight: 500,
              fontSize: "0.875rem",
              color: "#fff",
            }}
          >
            {title}
          </Box>
        </Box>
        {quickFilters.map((item) => (
          <QuickFilter {...item} type={type} />
        ))}
      </Box>
    </Box>
  );
};
